var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95627 14.75H19.9038C20.4838 14.75 20.9539 14.4142 20.9539 14C20.9539 13.5858 20.4838 13.25 19.9038 13.25H9.95627C9.37636 13.25 8.90625 13.5858 8.90625 14C8.90625 14.4142 9.37636 14.75 9.95627 14.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.995238 14.75H4.76667C5.31632 14.75 5.7619 14.4142 5.7619 14C5.7619 13.5858 5.31632 13.25 4.76667 13.25H0.995238C0.445583 13.25 0 13.5858 0 14C0 14.4142 0.445583 14.75 0.995238 14.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1875 14C4.1875 15.6569 5.5946 17 7.33036 17C9.06611 17 10.4732 15.6569 10.4732 14C10.4732 12.3431 9.06611 11 7.33036 11C5.5946 11 4.1875 12.3431 4.1875 14ZM8.90067 14C8.90067 14.8284 8.19712 15.5 7.32924 15.5C6.46137 15.5 5.75781 14.8284 5.75781 14C5.75781 13.1716 6.46137 12.5 7.32924 12.5C8.19712 12.5 8.90067 13.1716 8.90067 14Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.075 7.68555L1.1274 7.68555C0.547492 7.68555 0.0773821 8.02133 0.0773821 8.43555C0.0773821 8.84976 0.547492 9.18555 1.1274 9.18555L11.075 9.18555C11.6549 9.18555 12.125 8.84976 12.125 8.43555C12.125 8.02133 11.6549 7.68555 11.075 7.68555Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.036 7.68555L16.2646 7.68555C15.7149 7.68555 15.2693 8.02133 15.2693 8.43555C15.2693 8.84976 15.7149 9.18555 16.2646 9.18555H20.036C20.5857 9.18555 21.0312 8.84976 21.0312 8.43555C21.0312 8.02133 20.5857 7.68555 20.036 7.68555Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8438 8.43555C16.8438 6.77869 15.4366 5.43555 13.7009 5.43555C11.9651 5.43555 10.558 6.77869 10.558 8.43555C10.558 10.0924 11.9651 11.4355 13.7009 11.4355C15.4366 11.4355 16.8438 10.0924 16.8438 8.43555ZM12.1306 8.43555C12.1306 7.60712 12.8341 6.93555 13.702 6.93555C14.5699 6.93555 15.2734 7.60712 15.2734 8.43555C15.2734 9.26397 14.5699 9.93555 13.702 9.93555C12.8341 9.93555 12.1306 9.26397 12.1306 8.43555Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95627 3.75H19.9038C20.4838 3.75 20.9539 3.41421 20.9539 3C20.9539 2.58579 20.4838 2.25 19.9038 2.25H9.95627C9.37636 2.25 8.90625 2.58579 8.90625 3C8.90625 3.41421 9.37636 3.75 9.95627 3.75Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.995238 3.75H4.76667C5.31632 3.75 5.7619 3.41421 5.7619 3C5.7619 2.58579 5.31632 2.25 4.76667 2.25H0.995238C0.445583 2.25 0 2.58579 0 3C0 3.41421 0.445583 3.75 0.995238 3.75Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1875 3C4.1875 4.65685 5.5946 6 7.33036 6C9.06611 6 10.4732 4.65685 10.4732 3C10.4732 1.34315 9.06611 0 7.33036 0C5.5946 0 4.1875 1.34315 4.1875 3ZM8.90067 3C8.90067 3.82843 8.19712 4.5 7.32924 4.5C6.46137 4.5 5.75781 3.82843 5.75781 3C5.75781 2.17157 6.46137 1.5 7.32924 1.5C8.19712 1.5 8.90067 2.17157 8.90067 3Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a4ef9959099467841f897b50d99b3c0c.svg";
export { ForwardRef as ReactComponent };